import { api } from "./api";
import { fetchRule } from "./rule.service";
import { getTutorial } from "./tutorial.service";

const fetchDates = async() =>{
    try{
        const {data} = await api.get('/database/cronograma__c')
    
        if(!Array.isArray(data)){
            return [];
        }else{
            return data;
        }
    }catch(error:any){
        throw error;
    }
}


const GeneralItens = async() =>{
    try{
        //inscricao-67a521a53de8c3182e994da2
        const [dates, rules, tutorial] = await Promise.all([
            fetchDates(),
            fetchRule(),
            getTutorial('6787e5fde510835c7932dba3')
        ])
        
        return {dates, rules, tutorial};
    

    }catch(e){
        throw e;
    }
}

export default GeneralItens;